import { forwardRef, useEffect, useRef } from "react";
import { useFormContext, Controller } from "react-hook-form";
import { useParams } from "react-router-dom";
import { MDBRow, MDBCol } from "mdbreact";
import { Button, Label, TextArea } from "abs-ui-components";
import "./FeuEmissionFactorAnnex2.scss";
import { commonFormFields } from "../../FeuConstants";
import { API_ROUTES } from "../../FeuApiRoutes/FeuApiRoutes";
import { callApi } from "../../../../../services/MonitoringPlanService.js";
import { emitToasterMsg } from "../../../../../services/toasterUtility.js";
import { AUTOSAVE_SUCCESS_MESSAGE } from "../../../Mrv/Constants.js";
import AutoSave from "../../../../../common/AutoSave/AutoSave.js";



const FeuEmissionFactorAnnex2 = forwardRef(({ B36BiofuelEmissionFactor, refetchMonitoringData,vesselMstId }, ref) => {

    const { control, getValues, reset, formState } = useFormContext();
    const { isDirty } = formState;
    const lastManualSave = useRef(null);
    const manualSaveTriggered = useRef(false);

    useEffect(() => {
        if (B36BiofuelEmissionFactor) {
            reset(prev => ({ ...prev, b36: B36BiofuelEmissionFactor }));
        }
    }, [B36BiofuelEmissionFactor, reset]);

    AutoSave(ref, [], async () => {
        if (!isDirty) return;
        await handleSave(true);
    });


    const handleSave = async (isAuto = false) => {
        const formValues = getValues("b36");
        const payload = {
            ...commonFormFields.reduce((acc, { name }) => {
                acc[name] = formValues?.[name] || "";
                return acc;
            }, {}),
        };

        try {
            const b36BiofuelEmissions = await callApi({
                method: "POST",
                url: API_ROUTES.B36(vesselMstId),
                data: payload,
            });
            if (b36BiofuelEmissions?.isSuccess) {
                emitToasterMsg("success", "Table Biofuel Emission Factor Procedure", isAuto ? AUTOSAVE_SUCCESS_MESSAGE : "Created successfully");
                reset(prev => ({ ...prev, b36: formValues }));
                if (!isAuto) {
                    lastManualSave.current = Date.now();
                }
                if (typeof refetchMonitoringData === "function") {
                    await refetchMonitoringData();
                }
            }
            else {
                emitToasterMsg("error", "Table Biofuel Emission Factor Procedure", b36BiofuelEmissions?.errorMessage);
            }
        } catch (error) {
            emitToasterMsg("error", "Table Biofuel Emission Factor Procedure", error.errorMessage);
        }
    };

    return (
        <div className="b36-section-form mt-4">
            <MDBRow className="mb-2">
                <MDBCol md="4">
                    <h6 className="titles-font">Title of procedure</h6>
                </MDBCol>
                <MDBCol md="4">
                    <h6 className="titles-font">
                        Determination of emission factors</h6>
                </MDBCol>
            </MDBRow>
            {commonFormFields.map(({ label, name, maxLength }, index) => {
                const displayLabel =
                    label === "Description of procedure"
                        ? "Description of procedure (a brief description of the procedure can be provided if already existing outside the monitoring plan)"
                        : label;
                return (
                    <MDBRow className="align-items-center mb-3" key={index}>
                        <MDBCol md="4">
                            <Label name={displayLabel} bold />
                        </MDBCol>
                        <MDBCol md="4">
                            <Controller
                                name={`b36.${name}`}
                                control={control}
                                render={({ field }) => (
                                    <TextArea
                                        id={`b36_${name}`}
                                        className="textarea-resize"
                                        value={field?.value || ""}
                                        onChange={field.onChange}
                                        placeholder=""
                                        maxLength={maxLength}
                                        rows={1}
                                    />
                                )}
                            />
                        </MDBCol>
                    </MDBRow>
                );
            })}

            <div className="text-center">
                <Button id="b36_save_btn"
                    disabled={!isDirty}
                    onClick={async () => {
                        manualSaveTriggered.current = true;
                        await handleSave(false);
                    }}
                >Save</Button>
            </div>
        </div>
    );
});



export default FeuEmissionFactorAnnex2;